import { Alert, Select } from 'antd';
import { CloseOutlined, PlusCircleFilled } from '@ant-design/icons';
import styled, { createGlobalStyle } from 'styled-components';

export const GlobalPopupButtonStyles = createGlobalStyle`
  .segment-button-color {
    .ant-btn:not(:disabled) {
      background-color: #fff;
      border-color: #2B73E0 !important;
      color: #2B73E0 !important;
    }
    .ant-btn-primary:not(:disabled) {
      background-color: #2B73E0 !important;
      border-color: #2B73E0 !important;
      color: #fff !important;
    }
    .ant-btn:not(:disabled):hover {
      background-color: #fff;
      border-color: #5f91dd !important;
      color: #5f91dd !important;
    }
  
    .ant-btn-primary:not(:disabled):hover {
      background-color: #5f91dd !important;
      border-color: #5f91dd !important;
      color: #fff !important;
    }
  }
`;

export const PageContent = styled.div`
  margin: 16px;
  padding: 24px;
  background: #ffffff;
  border-radius: 4px;
  box-shadow: 1px 1px 2px rgba(0, 0, 0, 0.252406);
`;

export const PageContentHeader = styled.div`
  font-weight: 500;
  font-size: 16px;
  line-height: 22px;
  color: #335777;
  margin-bottom: 24px;
`;

export const SubTitle = styled.div`
  font-size: 14px;
  font-weight: 400;
`;

export const ContentWrapper = styled.div`
  padding: 0px 24px;
`;

export const SectionContainer = styled.div`
  border-radius: 10px;
  max-width: 65%;
  overflow: hidden;
  background-color: #fafafb;
`;

export const TitleContainer = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  background-color: #eef4fa;
  padding: 10px 16px;
  font-weight: 500;
  font-size: 15px;

  .section-no {
    height: 32px;
    width: 32px;
    background-color: #3f516f;
    border-radius: 50%;
    color: #ffffff;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 16px;
  }
`;

export const SectionContent = styled.div`
  margin: 16px 80px 16px 64px;
  .selection-info {
    color: #828891;
    font-size: 15px;
    font-weight: 500;
    padding-bottom: 12px;
  }
`;

export const DetailsContent = styled.div`
  margin: 24px 64px;
`;

export const CategoryLabel = styled.div`
  font-size: 12px;
  font-weight: 700;
  margin-bottom: 4px;
`;

export const CategoryLabel2 = styled.div`
  font-size: 12px;
  font-weight: 700;
`;

export const StyledSelect = styled(Select)`
  width: 100%;
  ${({ disabled }) =>
    disabled &&
    `
    .ant-select-selector {
      color: rgba(0, 0, 0, 0.5) !important;
    }
  `}
`;

export const ButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 24px;
  padding-bottom: 8px;
`;

export const StyledCloseIcon = styled(CloseOutlined)`
  position: absolute;
  top: 9px;
  right: -5px;
  color: #ff4d4f;
`;

export const StyledAddIcon = styled(PlusCircleFilled)`
  position: absolute;
  right: ${({ index }) => (index === 0 ? '-16px' : '-38px')};
  color: ${({ disabled }) => (disabled ? '#748AA1' : '#2B73E0')};
  cursor: ${({ disabled }) =>
    disabled ? 'not-allowed' : 'pointer'} !important;
  svg {
    width: 24px;
    height: 32px;
  }
`;

export const StyledAlert = styled(Alert)`
  margin-bottom: 16px;
`;

export const DisabledLabel = styled.div`
  background: #dde4ed;
  border: 1px solid #d0d7e3;
  border-radius: 5px;
  color: #748aa1;
  padding: 4px 8px;
  overflow: hidden;
  text-wrap: nowrap;
  text-overflow: ellipsis;
`;

export const StyledDivider = styled.div`
  border-top: 1px solid #bec3ca;
  margin: 6px 0px;
  width: ${({ width }) => width};
`;

export const DateAndUserInfo = styled.div`
  color: #335777;
  margin-top: 24px;
  font-size: 13px;
  font-weight: 500;
`;
